import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Bidding, BiddingStatus, BiddingUpdateAction } from '../../model/bidding';

// @ts-ignore
import * as am4core from "@amcharts/amcharts4/core";
// @ts-ignore
import * as am4charts from "@amcharts/amcharts4/charts";
// @ts-ignore
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-company-report',
  templateUrl: './company-report.component.html',
  styleUrls: ['./company-report.component.css'],
  providers: [DBService, AuthenticationService]
})

export class CompanyReportComponent implements OnInit {

  isNoUser: boolean;  
  company: Company[];
  userCompany: any;
  userCompanyUID: string;
  isCustomer: boolean;
  emptyData: boolean;
  isAdminUser: boolean;

  biddings: Bidding[];
  companies: Company[];
  companyFilter: string;

  opened: boolean;
  month = 'option1';

  months: any[];
  private selectedMonth;

  pendingParticipationsCount: number;
  participationsCount: number;
  soldAmount: number;
  totalPercent: number;

  constructor(private dbService: DBService, private authService: AuthenticationService, private zone: NgZone) {

    this.userCompanyUID = this.authService.getUserCompany();
    this.emptyData = true;

    this.initMonths();
    this.initData();

  }
  
  public initData() {
    this.isAdminUser = this.authService.isAdmin();

    if(this.userCompanyUID == "I-Ganhei") this.userCompanyUID = "-L_ji4pN0q6w4RjbaJOM";

    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies.filter(company => company.metaField > 0);
        this.company = companies.filter(company => company.uid === this.userCompanyUID);
        this.userCompany = this.company[0];

        this.dbService.list<Bidding>('biddings')
        .then(biddings => {
          this.biddings = biddings;
          if (!this.isAdminUser) {
            this.biddings = this.biddings.filter(bidding => bidding.companyUID == this.userCompany.uid);
          }
          this.processBiddings();
        });

      });
  }
  
  public reloadData() {

    this.isAdminUser = this.authService.isAdmin();
    this.userCompanyUID = this.companyFilter;

    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies.filter(company => company.metaField > 0);
        this.company = companies.filter(company => company.uid === this.userCompanyUID);
        this.userCompany = this.company[0];        

        this.dbService.list<Bidding>('biddings')
        .then(biddings => {
          this.biddings = biddings;
          if (!this.isAdminUser) {
            this.biddings = this.biddings.filter(bidding => bidding.companyUID == this.userCompany.uid);
          }
          this.processBiddings();
        });

      });
  }

  public processBiddings() {
    const currentYear = new Date().getUTCFullYear();

    const startDate = new Date(currentYear, this.selectedMonth - 1, 1).getTime();
    let finishDate = null;

    if (this.selectedMonth < 12) {
      finishDate = new Date(currentYear, this.selectedMonth, 1).getTime();
    } else {
      finishDate = new Date(currentYear + 1, 1, 1).getTime();
    }

    const partialBiddings = this.biddings
      .filter(a => a.biddingDate >= startDate && a.biddingDate < finishDate);

    this.soldAmount = partialBiddings
      .filter(b => b.status == BiddingStatus.EARNED)
      .map(b => b.earningPrice)
      .reduce((v1, v2) => v1 + v2, 0);

    var metaVar = this.userCompany.metaField; 
    var ganhoVar = this.soldAmount;
    this.totalPercent = 0;
    
    if(isNaN(metaVar) || isNaN(ganhoVar)){
      this.totalPercent = 0;
    } else {
      this.totalPercent = (ganhoVar/metaVar) * 100;
    }
    
    this.emptyData = false;
    this.loadChart();
  }

  public loadChart() {
    var chart = am4core.create("chartdiv", am4charts.GaugeChart);
    chart.innerRadius = am4core.percent(82);
    
    var axis = chart.xAxes.push(new am4charts.ValueAxis() as any);
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.renderer.radius = am4core.percent(80);
    axis.renderer.inside = true;
    axis.renderer.line.strokeOpacity = 1;
    axis.renderer.ticks.template.strokeOpacity = 1;
    axis.renderer.ticks.template.length = 10;
    axis.renderer.grid.template.disabled = true;
    axis.renderer.labels.template.radius = 40;
    axis.renderer.labels.template.adapter.add("text", function(text) {
      return text + "%";
    });
    
    var colorSet = new am4core.ColorSet();
    
    var axis2 = chart.xAxes.push(new am4charts.ValueAxis() as any);
    axis2.min = 0;
    axis2.max = 100;
    axis2.renderer.innerRadius = 10
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;
    
    var range0 = axis2.axisRanges.create();
    range0.value = 0;
    range0.endValue = 50;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = colorSet.getIndex(0);
    
    var range1 = axis2.axisRanges.create();
    range1.value = 50;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = colorSet.getIndex(2);
    
    var label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 45;
    label.x = am4core.percent(50);
    label.y = am4core.percent(100);
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    label.text = "0%";
    
    var hand = chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(20);
    hand.startWidth = 10;
    hand.pin.disabled = true;
    hand.value = 0;
    
    hand.events.on("propertychanged", function(ev) {
      range0.endValue = ev.target.value;
      range1.value = ev.target.value;
      axis2.invalidate();
    });

    chart.setTimeout(() => {
      var value = this.totalPercent;
      label.text = value + "%";
      var animation = new am4core.Animation(hand, {
        property: "value",
        to: value
      }, 1000, am4core.ease.cubicOut).start();
    }, 1000);
  }

  ngOnInit() {
  }

  public initMonths() {
    this.months = [];

    const date = new Date();
    const currentMonth = date.getUTCMonth();
    const currentYear = date.getUTCFullYear();

    for(let i = 0; i <= currentMonth; i++) {
      this.months.push(this.getMonthData(i + 1, currentYear));
    }

    this.selectedMonth = currentMonth + 1;
  }

  public getMonthData(month: number, year: number) {
    return { id: month, name: this.getMonth(month) + '/' + year };
  }

  public getMonth(month: number): string {
    let name = '';
    if (month === 1) {
      name = 'Janeiro';
    } else if (month === 2) {
      name = 'Fevereiro';
    } else if (month === 3) {
      name = 'Março';
    } else if (month === 4) {
      name = 'Abril';
    } else if (month === 5) {
      name = 'Maio';
    } else if (month === 6) {
      name = 'Junho';
    } else if (month === 7) {
      name = 'Julho';
    } else if (month === 8) {
      name = 'Agosto';
    } else if (month === 9) {
      name = 'Setembro';
    } else if (month === 10) {
      name = 'Outubro';
    } else if (month === 11) {
      name = 'Novembro';
    } else if (month === 12) {
      name = 'Dezembro';
    }

    return name;
  }

  public getSmallMonth(month: number): string {
    let name = '';
    if (month === 1) {
      name = 'Jan';
    } else if (month === 2) {
      name = 'Fev';
    } else if (month === 3) {
      name = 'Mar';
    } else if (month === 4) {
      name = 'Abr';
    } else if (month === 5) {
      name = 'Mai';
    } else if (month === 6) {
      name = 'Jun';
    } else if (month === 7) {
      name = 'Jul';
    } else if (month === 8) {
      name = 'Ago';
    } else if (month === 9) {
      name = 'Set';
    } else if (month === 10) {
      name = 'Out';
    } else if (month === 11) {
      name = 'Nov';
    } else if (month === 12) {
      name = 'Dez';
    }

    return name;
  }

  private changeMonth() {
    this.emptyData = true;
    if(this.companyFilter) 
      this.reloadData();
    else 
      this.initData();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/company-report/company-report.component.ts